import type { DiscoveredRouteModule } from '@/router/generator/types';

const FeatureNotEnabledView = () => import('@/views/error-pages/FeatureNotEnabledView.vue');
const SandboxView = () => import('@/views/ProjectsView.vue');
// Legacy component factory names expected by old modules
const FeatureNotEnabled = () => import('@/views/error-pages/FeatureNotEnabledView.vue');
const Sandbox = () => import('@/views/ProjectsView.vue');

export const NAME_FEATURE_NOT_ENABLED = 'FeatureNotEnabled';
export const NAME_SANDBOX = 'Sandbox';
export const PATH_FEATURE_NOT_ENABLED = '/feature-not-enabled';
export const PATH_SANDBOX = '/sandbox';

export const route: DiscoveredRouteModule = {
  id: 'root.utility.feature_not_enabled',
  scope: 'root',
  name: NAME_FEATURE_NOT_ENABLED,
  path: PATH_FEATURE_NOT_ENABLED,
  component: FeatureNotEnabledView,
  meta: { isErrorPage: true, requiresAuth: false, skipProjectCheck: true }
};


